/**
 * merge productCd for value display checkbox
 * @param hakudoShhnCd: product imported id
 * @param shhnCd: product local id
 * @returns mergeId
 */
function mergeProductId(hakudoShhnCd: string, shhnCd: string) {
  return `${hakudoShhnCd || 'null'}-${shhnCd || 'null'}`;
}

/**
 * split mergeId to hakudoShhnCd and shhnCd to request other api
 * @param mergeId: string constant two id of product
 * @returns two id of product {hakudoShhnCd, shhnCd}
 */
function splitProductId(mergeId: string) {
  const producIds = mergeId && mergeId?.split('-');
  return {
    hakudoShhnCd: producIds && producIds[0] !== 'null' ? producIds[0] : null,
    shhnCd: producIds && producIds[1] !== 'null' ? producIds[1] : null,
  };
}

export const productFormat = {
  mergeProductId,
  splitProductId,
};
